import clsx from 'clsx';
import logoUrl from '../../assets/interval-logo.png';

/**
 * The Interval wordmark.
 *
 * The source art is a 7697px master; this is a 720px copy, which is still
 * ~3x the largest size rendered here and so stays crisp on high-density
 * displays without shipping a 76KB asset for a 24px-tall header.
 *
 * The mark carries its own colour — purple and two blues on transparency — so
 * it sits correctly on both the light and dark grounds without a variant.
 */
export function IntervalLogo({
  className,
  height = 22,
}: {
  className?: string;
  height?: number;
}) {
  return (
    <img
      src={logoUrl}
      // Read as one word by screen readers; the tagline is decorative here.
      alt="Interval"
      height={height}
      style={{ height, width: 'auto' }}
      className={clsx('block select-none', className)}
      draggable={false}
    />
  );
}

/**
 * The wordmark with a brand-coloured sweep beneath it, for full-page waits.
 *
 * Same motion as the SSO interstitial the user just came through, so arriving
 * in the console does not feel like landing in a different product.
 */
export function IntervalLoader({ label }: { label: string }) {
  return (
    <div className="flex flex-col items-center gap-5">
      <IntervalLogo height={40} />

      <div
        className="relative h-[3px] w-52 overflow-hidden rounded-sm bg-surface-sunken"
        role="progressbar"
        aria-label={label}
      >
        <span className="absolute inset-y-0 left-0 w-[45%] animate-sweep rounded-sm bg-gradient-to-r from-[#7B4B8E] via-[#1D6FB8] to-[#3399CF]" />
      </div>

      <p className="text-2xs text-ink-faint">{label}</p>
    </div>
  );
}
